import { render, staticRenderFns } from "./work-form-select.vue?vue&type=template&id=1b5bf232&"
import script from "./work-form-select.vue?vue&type=script&lang=js&"
export * from "./work-form-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "work-form-select.vue"
export default component.exports